// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-headline_c125dca3{border-bottom:1px solid #dce1e5;padding-bottom:.667rem;margin-bottom:2rem}.page-headline__title_a4f98dfd{font-family:PitchBookFont,'Helvetica','Arial',sans-serif;font-size:2.167rem;line-height:1.5;letter-spacing:normal;color:#6185a6;font-stretch:normal}", ""]);
// Exports
export var pageHeadline = "page-headline_c125dca3";
export var pageHeadlineTitle = "page-headline__title_a4f98dfd";
export default ___CSS_LOADER_EXPORT___;
